(function () {
  const selectors = document.querySelectorAll('[data-rmds-frame-selector]');
  if (!selectors.length) return;

  function normalizedSize(title) {
    const match = String(title || '').toUpperCase().match(/\bA(?:0|1|2|3|4|5|6)\b/);
    return match ? match[0] : String(title || '').trim();
  }

  function formatMoney(cents) {
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency', currency
      }).format(Number(cents) / 100);
    } catch (_) {
      return `£${(Number(cents) / 100).toFixed(2)}`;
    }
  }

  function init(root) {
    const sizeSelect = root.querySelector('[data-rmds-size]');
    const sizePicker = root.querySelector('[data-rmds-size-picker]');
    const sizeCurrent = root.querySelector('[data-rmds-size-current]');
    const sizeCurrentPrice = root.querySelector('[data-rmds-size-current-price]');
    const sizeMenu = root.querySelector('[data-rmds-size-menu]');
    const nativeOption = root.querySelector('[data-rmds-native-option]');
    const extraOptionSelects = Array.from(root.querySelectorAll('[data-rmds-extra-option]'));
    const cards = Array.from(root.querySelectorAll('[data-rmds-frame]'));
    const error = root.querySelector('[data-rmds-error]');
    const fallbackAddButton = root.querySelector('[data-rmds-add]');
    const fallbackAddPrice = root.querySelector('[data-rmds-add-price]');
    const productContainer = root.closest('[data-section-id]') || root.closest('.product') || document;
    const form = productContainer.querySelector('form[data-product-form]');
    if (!sizeSelect || !form) return;

    let selectedCard = cards[0];
    let sizeUnit = 'in';
    try { sizeUnit = localStorage.getItem('rmds-size-unit') || 'in'; } catch (_) {}

    // Some product-option apps rewrite native <option> labels. Keep this
    // selector independent and restore the explicit "Size — Price" labels.
    function restoreSizeLabels() {
      Array.from(sizeSelect.options).forEach((option) => {
        if (option.dataset.display) option.textContent = option.dataset.display;
      });
    }

    function optionMatchesArtworkChoices(option) {
      return extraOptionSelects.every((select) => {
        const position = Number(select.dataset.optionPosition || 0);
        return !position || option.getAttribute(`data-option-${position}`) === select.value;
      });
    }

    function availableSizeOptions() {
      return Array.from(sizeSelect.options).filter(optionMatchesArtworkChoices);
    }

    function selectMatchingSize(preferredSize) {
      const options = availableSizeOptions();
      const match = options.find((option) => normalizedSize(option.dataset.title) === preferredSize) || options[0];
      if (match) sizeSelect.value = match.value;
      return match;
    }

    function syncCustomSizePicker() {
      const selected = sizeSelect.options[sizeSelect.selectedIndex];
      if (sizeCurrent && selected) sizeCurrent.textContent = selected.dataset[`label${sizeUnit === 'cm' ? 'Cm' : 'In'}`] || selected.dataset.title;
      if (sizeCurrentPrice && selected) sizeCurrentPrice.textContent = formatMoney(selected.dataset.price);
      root.querySelectorAll('[data-rmds-unit]').forEach((button) => {
        button.classList.toggle('is-active', button.dataset.rmdsUnit === sizeUnit);
      });
      if (sizeMenu) {
        Array.from(sizeMenu.querySelectorAll('[data-rmds-size-value]')).forEach((button) => {
          button.setAttribute('aria-selected', button.dataset.rmdsSizeValue === sizeSelect.value ? 'true' : 'false');
        });
      }
    }

    function buildCustomSizePicker() {
      if (!sizeMenu) return;
      sizeMenu.textContent = '';
      availableSizeOptions().forEach((option) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'rmds-size-picker__option';
        button.dataset.rmdsSizeValue = option.value;
        const label = document.createElement('span');
        label.textContent = option.dataset[`label${sizeUnit === 'cm' ? 'Cm' : 'In'}`] || option.dataset.title;
        const price = document.createElement('span');
        price.className = 'rmds-size-picker__option-price';
        price.textContent = formatMoney(option.dataset.price);
        button.append(label, price);
        button.addEventListener('click', () => {
          sizeSelect.value = option.value;
          sizeSelect.dispatchEvent(new Event('change', { bubbles: true }));
          if (sizePicker) sizePicker.open = false;
        });
        sizeMenu.appendChild(button);
      });
      syncCustomSizePicker();
    }

    root.querySelectorAll('[data-rmds-unit]').forEach((button) => {
      button.addEventListener('click', () => {
        sizeUnit = button.dataset.rmdsUnit;
        try { localStorage.setItem('rmds-size-unit', sizeUnit); } catch (_) {}
        buildCustomSizePicker();
      });
    });

    function selectedSize() {
      return normalizedSize(sizeSelect.options[sizeSelect.selectedIndex].dataset.title);
    }

    function setNativeVariant() {
      const option = sizeSelect.options[sizeSelect.selectedIndex];
      const sizeOptionPosition = Number(root.dataset.sizeOptionPosition || 1);
      nativeOption.value = option.getAttribute(`data-option-${sizeOptionPosition}`) || option.dataset.title;
      nativeOption.dispatchEvent(new Event('change', { bubbles: true }));
      const idInput = form.querySelector('[name="id"]');
      if (idInput) {
        idInput.value = option.value;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function switchToSelectedArtworkImage() {
      const option = sizeSelect.options[sizeSelect.selectedIndex];
      const mediaId = option && option.dataset.mediaId;
      if (!mediaId) return;

      // Use Cornerstone's own thumbnail handler so desktop, mobile, zoom and
      // the active thumbnail all remain synchronized with Shopify's variant image.
      const thumbnail = productContainer.querySelector(`.product__media-container.above-mobile [data-thumbnail-id="${mediaId}"]`)
        || productContainer.querySelector(`[data-thumbnail-id="${mediaId}"]`);
      if (thumbnail) thumbnail.click();
    }

    function artworkProperties() {
      return extraOptionSelects.reduce((properties, select) => {
        properties[`Artwork ${select.dataset.optionName || 'option'}`] = select.value;
        return properties;
      }, {});
    }

    function selectedAddonVariant() {
      if (selectedCard.dataset.master === 'unframed') return null;
      return findEmbeddedVariant(selectedCard, selectedSize());
    }

    function findEmbeddedVariant(card, size) {
      const node = Array.from(card.querySelectorAll('[data-rmds-addon-variant]')).find((item) => normalizedSize(item.dataset.size) === size);
      if (!node) return null;
      return { id: Number(node.dataset.id), price: Number(node.dataset.price), available: node.dataset.available === 'true' };
    }

    function updateDisplayedPrice(cents) {
      productContainer.querySelectorAll('[data-price]').forEach((node) => { node.textContent = formatMoney(cents); });
      productContainer.querySelectorAll('[data-compare-price]').forEach((node) => { node.textContent = ''; });
      if (fallbackAddPrice) fallbackAddPrice.textContent = formatMoney(cents);
    }

    function nativeAddButtonIsVisible() {
      const nativeButton = form.querySelector('[data-add-to-cart]');
      if (!nativeButton) return false;
      const style = window.getComputedStyle(nativeButton);
      return !nativeButton.disabled && style.display !== 'none' && style.visibility !== 'hidden' && nativeButton.getClientRects().length > 0;
    }

    function syncFallbackAddButton() {
      if (!fallbackAddButton) return;
      fallbackAddButton.hidden = nativeAddButtonIsVisible();
    }

    if (fallbackAddButton) {
      fallbackAddButton.addEventListener('click', () => {
        if (fallbackAddButton.disabled) return;
        const nativeButton = form.querySelector('[data-add-to-cart]');
        if (nativeButton && !nativeButton.disabled) nativeButton.click();
        else form.requestSubmit();
      });
    }

    function updateCards() {
      const size = selectedSize();
      const selectedOption = sizeSelect.options[sizeSelect.selectedIndex];
      const isDigital = selectedOption.dataset.digital === 'true';
      const artworkAvailable = selectedOption.dataset.available === 'true';
      cards.forEach((card) => {
        const priceNode = card.querySelector('[data-rmds-card-price]');
        if (card.dataset.master === 'unframed') {
          card.disabled = !artworkAvailable;
          priceNode.textContent = `${formatMoney(selectedOption.dataset.price)} total`;
          return;
        }
        if (!artworkAvailable) {
          card.disabled = true;
          priceNode.textContent = 'Artwork unavailable';
          return;
        }
        if (isDigital) {
          card.disabled = true;
          priceNode.textContent = 'Not available for digital downloads';
          return;
        }
        const variant = findEmbeddedVariant(card, size);
        card.disabled = !variant || !variant.available;
        priceNode.textContent = variant ? `${formatMoney(Number(selectedOption.dataset.price) + variant.price)} total` : 'Not available in this size';
      });
      if (selectedCard.disabled) {
        const fallbackCard = cards.find((card) => !card.disabled);
        if (fallbackCard) selectCard(fallbackCard);
        else if (fallbackAddButton) fallbackAddButton.disabled = true;
      }
    }

    function selectCard(card) {
      if (!card || card.disabled) return;
      cards.forEach((item) => {
        const active = item === card;
        item.classList.toggle('selected', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      selectedCard = card;
      error.hidden = true;
      if (fallbackAddButton) fallbackAddButton.disabled = card.disabled;
      if (card.dataset.master === 'unframed') {
        setNativeVariant();
        updateDisplayedPrice(sizeSelect.options[sizeSelect.selectedIndex].dataset.price);
      } else {
        const variant = selectedAddonVariant();
        if (variant) updateDisplayedPrice(Number(sizeSelect.options[sizeSelect.selectedIndex].dataset.price) + variant.price);
      }
    }

    cards.forEach((card) => card.addEventListener('click', () => selectCard(card)));
    extraOptionSelects.forEach((select) => select.addEventListener('change', () => {
      const previousSize = selectedSize();
      selectMatchingSize(previousSize);
      buildCustomSizePicker();
      restoreSizeLabels();
      updateCards();
      selectCard(selectedCard.disabled ? cards[0] : selectedCard);
      switchToSelectedArtworkImage();
    }));
    sizeSelect.addEventListener('change', () => {
      restoreSizeLabels();
      syncCustomSizePicker();
      updateCards();
      selectCard(selectedCard.disabled ? cards[0] : selectedCard);
    });

    form.addEventListener('submit', async (event) => {
      if (selectedCard.dataset.master === 'unframed') return;

      event.preventDefault();
      event.stopImmediatePropagation();
      const variant = selectedAddonVariant();
      if (!variant) {
        error.textContent = 'This frame is not available in the selected size.';
        error.hidden = false;
        return;
      }

      const button = form.querySelector('[data-add-to-cart]');
      const quantity = Number((form.querySelector('[name="quantity"]') || {}).value || 1);
      if (button) button.setAttribute('aria-disabled', 'true');
      if (fallbackAddButton) fallbackAddButton.disabled = true;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({
            items: [
              {
                id: Number(sizeSelect.value),
                quantity,
                properties: Object.assign({ '_Frame selection': selectedCard.dataset.rmdsFrame }, artworkProperties())
              },
              {
                id: variant.id,
                quantity,
                properties: {
                Artwork: root.dataset.productTitle,
                Frame: selectedCard.dataset.rmdsFrame,
                '_Artwork URL': root.dataset.productUrl,
                '_Artwork handle': root.dataset.productHandle,
                '_Artwork product ID': root.dataset.productId,
                '_Artwork variant ID': sizeSelect.value,
                '_Artwork image': sizeSelect.options[sizeSelect.selectedIndex].dataset.image || root.dataset.productImage
                }
              }
            ]
          })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'The framed print could not be added.');
        window.location.assign('/cart');
      } catch (e) {
        error.textContent = e.message;
        error.hidden = false;
        if (button) button.removeAttribute('aria-disabled');
        if (fallbackAddButton) fallbackAddButton.disabled = false;
      }
    }, true);

    selectMatchingSize(normalizedSize(sizeSelect.options[sizeSelect.selectedIndex].dataset.title));
    updateCards();
    buildCustomSizePicker();
    restoreSizeLabels();
    // Restore once more after third-party product option scripts initialise.
    window.setTimeout(restoreSizeLabels, 500);
    window.setTimeout(restoreSizeLabels, 1500);
    syncFallbackAddButton();
    window.setTimeout(syncFallbackAddButton, 500);
    window.setTimeout(syncFallbackAddButton, 1500);
    selectCard(selectedCard);

    // Globo may load after the theme. Hide only its former frame widget on
    // pages using this replacement selector; leave the app untouched elsewhere.
    function hideLegacyFrameWidget() {
      const blocks = root.closest('.product-blocks');
      if (!blocks) return;
      Array.from(blocks.children).forEach((child) => {
        if (child === root || child.contains(root)) return;
        const text = String(child.textContent || '').toLowerCase();
        if (text.includes('want your print ready to hang') || text.includes('select a frame below')) {
          child.hidden = true;
        }
      });
    }
    hideLegacyFrameWidget();
    const legacyObserver = new MutationObserver(hideLegacyFrameWidget);
    legacyObserver.observe(root.closest('.product-blocks') || root, { childList: true, subtree: true });
    window.setTimeout(() => legacyObserver.disconnect(), 5000);
  }

  selectors.forEach(init);
})();
